import React, { useEffect, useState, useRef } from "react";
import {
  showSnackbar,
  hideSnackbar,
} from "../../../store/slices/snackbarSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  getCategoryList,
  uploadCategoryVideo,
  getCategoryVideoListById,
  getCategoryVideoById,
  updateCategoryVideo,
  deleteCategoryVideo,
} from "../adminSlice";
import { InputField, Submitbtn } from "../../../Component";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import AddMoreBtn from "../../../Component/addMoreBtn";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import AdminTable from "../../../Component/adminTable";
import { callback } from "chart.js/dist/helpers/helpers.core";

const EditDeleteCategoryVideos = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [categoryList, setCategoryList] = useState<any>([]);
  const [categoryVideoList, setCategoryVideoList] = useState<any>([]);
  const [category, setCateogry] = useState<any>();
  const initialVal = {
    videoName: "",
    order: "",
    videoUrl: "",
    videoPreview: "",
    videoId: "",
  };
  const [categoryVideos, setCateogryVideos] = useState<any>(initialVal);
  const [previousVideoData, setPreviousVideoData] = useState<any>([initialVal]);
  const [isEditMode, setisEditMode] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [categoryVideos]);
  useEffect(() => {
    dispatch(
      getCategoryList({
        params: {},
        callback: (res: any) => {
          setCategoryList([...res].sort((a, b) => a?.order - b?.order));
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: "error" }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      }),
    );
  }, []);
  const handleGoBack = () => {
    setisEditMode(false);
  };
  useEffect(() => {
    if (category?._id) {
      getCategoryVideoList(category._id);
    } else {
      setCategoryVideoList([]); // clear table when category is cleared
    }
  }, [category?._id]);
  const getCategoryVideoList = (categoryId: any) => {
    dispatch(
      getCategoryVideoListById({
        id: categoryId,
        callback: (res: any) => {
          if (res?.status === "success") {
            setCategoryVideoList(res?.data);
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
          }
        },
        errorCallback: () => { },
      }),
    );
  };
  const handleEdit = (value: any) => {
    if (value) {
      setisEditMode(true);
      dispatch(
        getCategoryVideoById({
          id: value?._id,
          callback: (res: any) => {
            if (res?.status === "success") {
              const matchCategoryId = categoryList.filter(
                (item: any) => item?._id === res?.data?.categoryId,
              );
              setCateogry(matchCategoryId[0]);
              const updatedResObj = {
                videoName: res?.data?.videoName || "",
                order: res?.data?.order || "",
                videoUrl: res?.data?.videoUrl || "",
                videoPreview: res?.data?.videoUrl || "",
                videoId: res?.data?._id || "",
              };
              setPreviousVideoData(updatedResObj);
              setCateogryVideos(updatedResObj);
              dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
              setTimeout(() => {
                dispatch(hideSnackbar());
              }, 5000);
            }
          },
          errorCallback: () => { },
        }),
      );
    }
  };

  const handleDelete = (value: any) => {
    setisEditMode(false);
    dispatch(
      deleteCategoryVideo({
        id: value?._id,
        callback: (res: any) => {
          if (res?.status === "success") {
            getCategoryVideoList(value?.categoryId);
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: "error" }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      }),
    );
  };
  const onChangeCategory = (value: any) => {
    setCateogry(value);
    if (value) {
      getCategoryVideoList(value?._id);
    }
  };
  const onchangeCategoryVideo = (value: any, key: string) => {
    if (key === "videoName" || key === "order") {
      setCateogryVideos((prev: any) => ({
        ...prev,
        [key]: value,
      }));
      return;
    } else if (key === "video") {
      const MAX_SIZE = 150 * 1024 * 1024;
      const reader = new FileReader();
      const file = value.target.files[0];
      if (file?.size > MAX_SIZE) {
        dispatch(
          showSnackbar({
            message: "Video Size must be less than 200mb!!",
            type: "error",
          }),
        );
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
        return;
      }
      reader.onloadend = () => {
        setCateogryVideos((prev: any) => ({
          ...prev,
          ["videoPreview"]: reader.result,
        }));
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadCategoryVideo({
          params: file,
          callback: (res: any) => {
            if (res?.data) {
              setCateogryVideos((prev: any) => ({
                ...prev,
                ["videoUrl"]: res?.data?.name,
                ["videoPreview"]: res?.data?.url,
              }));
            }
          },
          errorCallback: () => { },
        }),
      );
    }
  };

  const handelSubmit = (e: any) => {
    e.preventDefault();
    const postData: any = {};
    if (previousVideoData?.videoName !== categoryVideos?.videoName) {
      postData["videoName"] = categoryVideos?.videoName;
    }
    if (previousVideoData?.order !== categoryVideos?.order) {
      postData["order"] = categoryVideos?.order;
    }
    if (previousVideoData?.videoUrl !== categoryVideos?.videoUrl) {
      postData["videoUrl"] = categoryVideos?.videoUrl;
    }
    dispatch(
      updateCategoryVideo({
        id: categoryVideos?.videoId,
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
            setisEditMode(false);
            getCategoryVideoList(category?._id);
          }
        },
        errorCallback: () => { },
      }),
    );
  };
  const validations = () => {
    if (
      categoryVideos?.videoName === "" ||
      categoryVideos?.order === "" ||
      categoryVideos?.videoUrl === ""
    ) {
      return true;
    }
  };

  const renderTable = () => {
    return (
      <div className="row bxshadow p-3 borderRadius  mx-1 mb-3">
        <div>
          <AdminTable
            tableData={categoryVideoList ? categoryVideoList : []}
            pagename={"categoryVideo"}
            tableHead={[
              "S.N",
              "Video Name",
              "Order No.",
              "Video Preview",
              "Action",
            ]}
            handleEdit={(value: any) => handleEdit(value)}
            handleDelete={(value: any) => handleDelete(value)}
            edit={true}
          />
        </div>
      </div>
    );
  };
  const renderEditMode = () => {
    return (
      <form onSubmit={handelSubmit}>
        <div className='d-flex align-items-center'>
          <LabelInput labelName={"Upload Category Video"} isRequired />
          <span className="required font12 fw-bold ms-2 mb-2">(Video files larger than 150 MB are not allowed)</span>
        </div>
        <div className="row gx-5">
          <div className="col-md-6 mb-3">
            <div className="row bxshadow p-2 borderRadius mb-4 position-relative">
              <div className="col-md-7 mb-4">
                <LabelInput labelName={"Video Name"} isRequired />
                <InputField
                  // key={"ex2"}
                  placeholder={`Enter Video Name`}
                  setInputText={(value: any) =>
                    onchangeCategoryVideo(value, "videoName")
                  }
                  value={categoryVideos.videoName}
                  disabled={category === undefined}
                />
              </div>
              <div className="col-md-4 mb-4">
                <LabelInput labelName={"Order number"} isRequired />
                <InputField
                  // key={"ex2"}
                  placeholder={`Order  No. ${categoryVideos?.order}`}
                  setInputText={(value: any) =>
                    onchangeCategoryVideo(value, "order")
                  }
                  value={categoryVideos.order}
                  maxLength={2}
                  disabled={category === undefined}
                />
              </div>
              <div className="col-md-2 mb-3">
                <LabelInput labelName={"Select Video"} isRequired />
                <div className="d-flex">
                  <ImagePickerAndViewer
                    value={categoryVideos?.videoUrl}
                    handleChange={(value: any) =>
                      onchangeCategoryVideo(value, "video")
                    }
                    htmlFor={`video-upload-${categoryVideos?.order}`}
                    doctype={"video"}
                    disabled={category === undefined}
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Video Preview"} />
                <div
                  className="video-thumbnail-holder p-1"
                  style={{
                    width: "200px",
                    height: "150px",
                    border: "solid 1px #000",
                  }}
                >
                  {categoryVideos?.videoUrl ? (
                    <video
                      ref={videoRef}
                      className="videoClass d-flex align-items-center justify-content-center"
                      controls
                      poster="images/my_thumbnail.jpg"
                      autoPlay
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <source
                        src={categoryVideos?.videoPreview}
                        type="video/mp4"
                      />
                    </video>
                  ) : (
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        backgroundColor: "#f15822",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <h5 className="colorWhite fw-500">No Video Uploaded</h5>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-2 my-3 mx-auto">
          <Submitbtn name={"Submit"} disabled={validations()} />
        </div>
      </form>
    );
  };

  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete Category"}
          breadCrumb={""}
          isEditMode={isEditMode}
          setisEditMode={setisEditMode}
          cancelEdit={() => handleGoBack()}
        />
      </div>
      <div className="formDiv">
        <div className="row bxshadow p-2 borderRadius mb-4 w-25">
          <div className="col-md-12">
            <LabelInput labelName={"Select Category"} isRequired />
            <DropdownWithClear
              labelName={"Select Category"}
              setInputText={(value: any) => onChangeCategory(value)}
              options={categoryList}
              value={category}
              defaultValue={category?._id}
              disabled={isEditMode}
            />
          </div>
        </div>
        {isEditMode ? renderEditMode() : renderTable()}
      </div>
    </div>
  );
};

export default EditDeleteCategoryVideos;
